var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBscs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 26,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11.399,
    cy: 18.049,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.7,
    cy: 18.637,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.693,
    cy: 18.744,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.486,
    cy: 18.236,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.265,
    cy: 17.005,
    r: 1.084
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.244,
    cy: 14.985,
    r: 1.218
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.452,
    cy: 16.39,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.833,
    cy: 15.6,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.335,
    cy: 14.249,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.144,
    cy: 12.336,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.435,
    cy: 9.887,
    r: 1.084
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.435,
    cy: 7.038,
    r: 1.218
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.833,
    cy: 12.416,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.245,
    cy: 10.717,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.138,
    cy: 8.71,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.646,
    cy: 6.502,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.877,
    cy: 4.281,
    r: 1.084
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.897,
    cy: 2.261,
    r: 1.218
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.506,
    cy: 8.456,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.282,
    cy: 6.85,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.633,
    cy: 5.352,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.546,
    cy: 4.148,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.995,
    cy: 3.452,
    r: 1.084
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.845,
    cy: 3.452,
    r: 1.218
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.479,
    cy: 6.837,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.165,
    cy: 6.262,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.172,
    cy: 6.154,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.38,
    cy: 6.663,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.601,
    cy: 7.894,
    r: 1.084
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.621,
    cy: 9.914,
    r: 1.218
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.426,
    cy: 8.509,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.045,
    cy: 9.299,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.53,
    cy: 10.637,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.734,
    cy: 12.563,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.43,
    cy: 14.998,
    r: 1.084
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.43,
    cy: 17.861,
    r: 1.218
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.045,
    cy: 12.483,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.634,
    cy: 14.182,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.728,
    cy: 16.189,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.219,
    cy: 18.397,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-85.935 15.992 20.619)",
    cx: 15.992,
    cy: 20.619,
    r: 1.084
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.968,
    cy: 22.638,
    r: 1.218
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.373,
    cy: 16.443,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.583,
    cy: 18.049,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.246,
    cy: 19.547,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.319,
    cy: 20.738,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.884,
    cy: 21.447,
    r: 1.084
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.021,
    cy: 21.447,
    r: 1.218
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.286 12.443c.2.013.388-.147.388-.348 0-.2-.148-.388-.348-.388a.472.472 0 00-.188.04c.201-.067.295-.28.228-.482-.067-.2-.281-.294-.482-.227-.053.027-.12.053-.16.107a.353.353 0 00.026-.522c-.147-.147-.374-.174-.521-.027a.341.341 0 00-.107.161.362.362 0 00-.174-.495.362.362 0 00-.495.174.427.427 0 00-.04.187.374.374 0 00-.348-.401.374.374 0 00-.402.348c0 .067.014.133.04.187-.066-.2-.28-.294-.481-.227-.2.066-.295.28-.228.481a.38.38 0 00.107.147.353.353 0 00-.521-.026c-.148.147-.174.374-.027.521.04.054.093.08.16.107a.323.323 0 00-.481.148.362.362 0 00.174.495c.053.026.12.04.187.04a.374.374 0 00-.401.348c-.014.2.133.388.347.401a.427.427 0 00.188-.04c-.2.067-.295.28-.228.482.067.2.281.294.482.227.053-.027.12-.054.16-.107a.38.38 0 00.495.575.341.341 0 00.108-.16.362.362 0 00.174.495.362.362 0 00.495-.174.427.427 0 00.04-.188c-.014.201.147.388.348.388.2 0 .388-.147.388-.347a.472.472 0 00-.04-.188c.066.201.28.295.481.228.2-.067.294-.281.228-.482-.027-.053-.054-.12-.108-.16.134.16.375.173.522.026.147-.147.174-.374.027-.521a.341.341 0 00-.16-.108.362.362 0 00.495-.173c.08-.188.013-.415-.174-.495a.594.594 0 00-.174-.027zM26.879 25.554a1.6 1.6 0 01-.642-.468 1.095 1.095 0 01-.228-.629c0-.04.014-.067.04-.093a.152.152 0 01.108-.04h.334c.08 0 .147.053.174.133.053.201.174.388.361.509.254.16.549.227.843.214.388 0 .682-.067.883-.214a.704.704 0 00.294-.576.524.524 0 00-.147-.388 1.161 1.161 0 00-.414-.267 7.589 7.589 0 00-.843-.281 4.566 4.566 0 01-.843-.321 1.23 1.23 0 01-.482-.428 1.208 1.208 0 01-.16-.643c0-.24.066-.468.2-.668.147-.201.348-.362.589-.469.28-.12.589-.174.896-.174.321-.013.63.054.924.188.227.107.428.267.588.481.12.174.2.375.214.576 0 .08-.053.147-.134.147h-.361a.152.152 0 01-.107-.04c-.04-.027-.053-.067-.067-.107a.715.715 0 00-.334-.495 1.246 1.246 0 00-.723-.188 1.332 1.332 0 00-.749.188.6.6 0 00-.28.548c0 .147.04.294.133.401.107.12.24.215.388.268.254.107.508.187.776.268.321.08.629.187.923.334.2.094.375.228.509.415.12.187.173.415.16.629.013.401-.174.776-.495 1.017-.334.24-.776.36-1.338.36-.334 0-.682-.066-.99-.187zM31.455 25.233c-.321-.334-.495-.789-.522-1.378 0-.12-.013-.32-.013-.615 0-.294 0-.495.013-.616.027-.588.187-1.043.522-1.378.32-.334.79-.495 1.405-.508.36-.013.722.067 1.043.214.522.24.856.75.883 1.325 0 .04-.013.08-.04.107a.152.152 0 01-.107.04h-.348a.152.152 0 01-.107-.04.259.259 0 01-.067-.12c-.08-.349-.214-.603-.428-.75a1.404 1.404 0 00-.83-.214c-.802 0-1.217.441-1.257 1.338 0 .12-.013.32-.013.575 0 .254 0 .455.013.589.027.896.455 1.338 1.258 1.338a1.38 1.38 0 00.83-.214c.2-.148.347-.388.427-.736.014-.04.027-.08.067-.12a.152.152 0 01.107-.04h.348c.04 0 .08.013.107.04.027.026.054.066.04.106a1.526 1.526 0 01-.883 1.325c-.32.16-.682.227-1.043.214-.616.013-1.084-.147-1.405-.482zM36.298 25.621c-.027-.026-.04-.067-.04-.12v-4.522c0-.04.013-.08.04-.12a.152.152 0 01.107-.04h.348c.04 0 .08.013.12.04.027.026.04.08.04.12V25.5c0 .08-.066.16-.147.16h-.361a.152.152 0 01-.107-.04zM38.693 25.621c-.027-.026-.04-.067-.04-.12v-4.522c0-.04.013-.094.04-.12a.152.152 0 01.107-.04h2.85c.08-.014.16.053.16.133v.281c0 .04-.013.08-.04.107a.216.216 0 01-.12.04h-2.355v1.539h2.208c.04 0 .093.013.12.04.027.027.04.08.04.12v.241c0 .04-.013.08-.04.12-.027.027-.08.04-.12.04h-2.208v1.606h2.422c.04 0 .093.014.12.04.027.027.054.08.04.12v.255c0 .04-.013.08-.053.12-.027.027-.08.04-.12.04H38.8c-.04.014-.08-.013-.107-.04zM43.39 25.621c-.028-.026-.041-.067-.041-.12v-4.522c0-.04.013-.094.04-.12a.152.152 0 01.107-.04h.308c.04 0 .067.013.107.026.027.027.053.04.067.067l2.314 3.572v-3.492c0-.04.014-.094.04-.12.027-.027.067-.04.121-.04h.308c.08-.014.16.053.16.133V25.501c0 .04-.013.08-.04.12a.17.17 0 01-.12.054h-.308a.186.186 0 01-.16-.094l-2.315-3.532v3.479c0 .04-.014.08-.04.12-.027.027-.067.054-.12.04h-.322a.47.47 0 01-.107-.067zM48.995 25.233c-.321-.334-.495-.789-.522-1.378v-.615-.616c.027-.588.188-1.043.522-1.378.321-.334.79-.495 1.405-.508.361-.013.722.067 1.043.214.522.24.857.75.883 1.325 0 .04-.013.08-.04.107a.152.152 0 01-.107.04h-.348a.152.152 0 01-.107-.04.259.259 0 01-.066-.12c-.08-.349-.215-.603-.429-.75a1.404 1.404 0 00-.83-.214c-.802 0-1.217.441-1.257 1.338 0 .12-.013.32-.013.575 0 .254 0 .455.013.589.027.896.455 1.338 1.258 1.338.294.013.575-.054.83-.214.213-.148.347-.388.428-.736.013-.04.026-.08.066-.12a.152.152 0 01.107-.04h.348c.04 0 .08.013.107.04.027.026.054.066.04.106a1.526 1.526 0 01-.883 1.325c-.32.16-.682.227-1.043.214-.616.013-1.084-.147-1.405-.482zM53.838 25.621c-.026-.026-.04-.067-.04-.12v-4.522c0-.04.014-.094.04-.12a.152.152 0 01.107-.04h2.85c.08-.014.16.053.16.146v.281c0 .04-.013.08-.04.107a.216.216 0 01-.12.04H54.44v1.54h2.208c.08 0 .16.053.16.146v.267c0 .041-.013.081-.04.121-.026.027-.08.04-.12.04H54.44v1.606h2.422c.04 0 .094.013.12.04.027.027.054.08.04.12v.255c0 .04-.013.08-.053.12-.027.027-.08.04-.12.04h-2.904c-.04-.013-.093-.04-.107-.067zM60.755 25.621c-.026-.026-.04-.067-.04-.12v-4.522c0-.04.014-.08.04-.12a.152.152 0 01.107-.04h.348c.04 0 .08.013.107.04.027.026.04.066.04.12v4.107h2.329c.04 0 .093.014.12.04.027.027.04.067.04.12v.268c0 .04-.013.08-.053.12-.027.028-.067.04-.12.04h-2.81a.203.203 0 01-.108-.053zM65.157 25.621c-.027-.026-.04-.067-.04-.12v-4.522c0-.04.013-.094.04-.12a.152.152 0 01.107-.04h2.85c.08-.014.16.053.16.133v.281c0 .04-.013.08-.04.107a.216.216 0 01-.12.04H65.76v1.539h2.208c.04 0 .094.013.12.04.027.027.054.08.04.12v.241c0 .04-.013.08-.04.12-.026.027-.08.04-.12.04h-2.208v1.606h2.422c.04 0 .094.014.12.04.027.027.054.08.04.12v.255c0 .04-.013.08-.053.12-.027.027-.08.04-.12.04h-2.904c-.04.014-.08-.013-.107-.04zM69.398 25.621a.145.145 0 01-.04-.093l.014-.08 1.712-4.483a.208.208 0 01.228-.147h.441c.094-.013.188.054.228.147l1.712 4.482.014.08c0 .04-.014.068-.04.094a.152.152 0 01-.108.04h-.32a.152.152 0 01-.108-.04c-.026-.026-.053-.053-.053-.08l-.388-.99h-2.315l-.374.99a.19.19 0 01-.174.12h-.335a.121.121 0 01-.094-.04zm1.178-1.645h1.9l-.95-2.489-.95 2.489zM75.004 25.621c-.026-.026-.04-.067-.04-.12v-4.522c0-.04.014-.094.04-.12a.152.152 0 01.107-.04h1.686c.522 0 .937.12 1.231.374.294.24.442.602.442 1.07.04.629-.375 1.19-.99 1.338l1.07 1.846c.013.027.013.054.027.08a.144.144 0 01-.134.135h-.308c-.053 0-.12-.014-.16-.054a.524.524 0 01-.107-.134l-1.017-1.766H75.62v1.793c0 .04-.014.08-.054.12-.026.027-.08.054-.12.04h-.335a.152.152 0 01-.107-.04zm1.78-2.488c.696 0 1.043-.295 1.043-.883 0-.589-.347-.883-1.043-.883H75.62v1.752l1.164.014zM80.048 25.621c-.026-.026-.04-.067-.04-.12v-4.522c0-.04.014-.094.04-.12a.152.152 0 01.107-.04h.308c.04 0 .067.013.107.026.027.027.054.04.067.067l2.315 3.572v-3.492c0-.04.013-.094.04-.12a.152.152 0 01.107-.04h.308c.08 0 .16.053.16.147v4.535c0 .04-.013.08-.04.12-.027.028-.067.054-.107.054h-.308a.186.186 0 01-.16-.093l-2.315-3.533v3.48c0 .04-.013.08-.04.12-.027.026-.067.053-.107.04h-.321c-.04-.027-.094-.054-.12-.08zM85.373 25.621c-.026-.026-.04-.067-.04-.12v-4.522c0-.04.014-.08.04-.12a.152.152 0 01.107-.04h.348c.08-.014.147.053.16.133v4.549c0 .04-.013.08-.04.12a.152.152 0 01-.106.04h-.348c-.054 0-.094-.013-.12-.04zM87.768 25.621c-.026-.026-.04-.067-.04-.12v-4.522c0-.04.014-.094.04-.12a.152.152 0 01.107-.04h.308c.04 0 .067.013.107.026.027.027.054.04.067.067l2.315 3.572v-3.492c0-.04.013-.094.04-.12.026-.027.067-.04.12-.04h.308c.08-.014.16.053.16.133V25.501c0 .04-.013.08-.04.12a.17.17 0 01-.12.054h-.308a.186.186 0 01-.16-.094l-2.315-3.532v3.479c0 .04-.013.08-.04.12-.027.027-.067.054-.107.04h-.321c-.054-.026-.094-.04-.12-.067zM93.388 25.233c-.335-.334-.509-.776-.536-1.35v-.657-.655c.014-.562.201-1.004.536-1.338.334-.335.802-.495 1.404-.495.362-.013.71.067 1.03.214.255.12.469.308.643.535.134.16.2.361.227.575v.014c0 .04-.013.067-.04.094a.152.152 0 01-.107.04h-.388a.248.248 0 01-.094-.027c-.026-.027-.053-.067-.053-.107a1.118 1.118 0 00-.415-.549c-.24-.16-.522-.24-.803-.227a1.25 1.25 0 00-.91.321c-.227.214-.334.535-.347.99V23.842c.013.441.134.776.348.99.254.227.575.334.91.321.347.013.682-.094.936-.321.24-.214.348-.535.348-.963v-.295H95.02a.122.122 0 01-.107-.053c-.027-.027-.054-.08-.04-.12v-.215c0-.04.013-.08.04-.12.027-.027.067-.054.107-.054h1.552c.08 0 .16.067.16.148v.669a1.96 1.96 0 01-.227.99 1.581 1.581 0 01-.669.655c-.321.16-.682.241-1.044.228-.602.026-1.07-.134-1.404-.469zM59.27 9.151c-.736-.856-1.913-1.485-3.545-1.886l-2.636-.642c-1.579-.402-2.569-.79-2.983-1.164-.415-.375-.616-.923-.616-1.646 0-.79.294-1.391.883-1.78.589-.4 1.472-.601 2.622-.601 1.419 0 2.516.28 3.278.83.549.414.964.976 1.205 1.618.013.054.053.08.093.08 1.311.027 1.686-2.502 1.686-2.502 0-.24.027-.401-.401-.521a21.733 21.733 0 00-3.05-.656 21.497 21.497 0 00-3.212-.254c-2.074 0-3.693.481-4.843 1.431-1.15.95-1.726 2.302-1.726 4.014 0 1.432.348 2.529 1.043 3.291.696.776 1.9 1.379 3.613 1.807l2.622.642c1.351.334 2.235.696 2.663 1.084.428.388.642.936.642 1.632 0 .883-.321 1.552-.95 2.007-.629.455-1.552.682-2.77.682-1.498 0-2.662-.321-3.505-.963-.843-.642-1.378-1.62-1.619-2.917h-.04c-.803 0-1.23.937-1.338 1.646-.107.575-.107 1.86-.107 1.86 0 .36 0 .615.589.802.936.295 1.9.535 2.863.696 1.124.187 2.261.294 3.412.294 2.381 0 4.174-.455 5.391-1.364 1.218-.91 1.833-2.248 1.833-4 0-.094-.013-.175-.013-.268-.04-1.365-.401-2.449-1.084-3.252zM95.81 9.151c-.737-.856-1.914-1.485-3.546-1.886l-2.636-.642c-1.579-.402-2.582-.79-2.984-1.164-.414-.375-.615-.923-.615-1.646 0-.79.294-1.391.883-1.78.589-.387 1.472-.601 2.622-.601 1.419 0 2.516.28 3.278.83.549.414.964.976 1.204 1.618.027.054.054.08.094.08 1.298.027 1.7-2.502 1.7-2.502 0-.24.026-.401-.402-.521a21.733 21.733 0 00-3.05-.656 21.497 21.497 0 00-3.212-.254c-2.073 0-3.679.481-4.843 1.431-1.15.964-1.726 2.302-1.726 4.014 0 1.432.348 2.529 1.044 3.291.695.776 1.9 1.379 3.612 1.807l2.622.642c1.352.334 2.235.696 2.663 1.084.428.388.642.936.642 1.632 0 .883-.321 1.552-.95 2.007-.629.455-1.552.682-2.77.682-1.498 0-2.662-.321-3.505-.963-.843-.642-1.378-1.62-1.619-2.917h-.026c-.803 0-1.231.937-1.338 1.646-.107.575-.107 1.86-.107 1.86 0 .36 0 .615.575.802.937.295 1.9.535 2.863.696 1.124.187 2.261.294 3.412.294 2.381 0 4.174-.455 5.392-1.364 1.217-.91 1.833-2.248 1.833-4 0-.094-.014-.175-.014-.268-.067-1.365-.414-2.449-1.097-3.252zM41.81 9.646c-.963-.789-2.368-1.27-4.174-1.444 1.498-.161 2.636-.549 3.398-1.178.763-.629 1.151-1.472 1.151-2.529 0-1.485-.549-2.595-1.66-3.331C39.416.428 37.77.054 35.55.054h-9.46v.214c0 .588.134 1.003.389 1.244.08.08.174.134.267.174a.6.6 0 01.361.562v1.284h.014V14.53h-.014v1.285a.6.6 0 01-.36.562c-.094.04-.188.107-.268.174-.255.241-.388.656-.388 1.244v.215h8.79c2.89 0 5.017-.415 6.368-1.258 1.352-.843 2.034-2.154 2.02-3.934 0-.441-.066-.883-.2-1.297a3.773 3.773 0 00-1.258-1.874zm-10.007-8.12h1.592c1.431 0 2.462.24 3.117.708.656.469.977 1.231.977 2.275 0 1.03-.335 1.793-1.004 2.301-.669.495-1.699.75-3.09.75h-1.592V1.524zm5.164 14.101c-.75.615-1.886.91-3.425.91h-1.74V8.99h1.74c1.525 0 2.662.321 3.412.95.307.267.562.602.736.977.28.588.414 1.244.4 1.886-.012 1.271-.387 2.221-1.123 2.823zM68.529 4.442l-.027.067c.013-.027.027-.04.027-.067z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5 12.75h-1.097a1.375 1.375 0 00-1.271.91c-.321.857-.763 1.526-1.325 2.007-.736.642-1.699.963-2.876.963-1.726 0-2.997-.615-3.827-1.86-.428-.641-.736-1.444-.95-2.448a15.942 15.942 0 01-.294-3.291c0-1.74.187-3.17.562-4.308.027-.08.053-.147.08-.228l.027-.066c.669-1.713 2.435-2.944 4.522-2.944 2.328 0 4.268 1.525 4.71 3.546 1.766-.067 1.498-3.492 1.498-3.492 0-.027-.013-.04-.04-.054A23.143 23.143 0 0075.673.388a15.632 15.632 0 00-3.25-.375c-2.971 0-5.312.803-7.025 2.422-1.726 1.619-2.582 3.813-2.582 6.583-.014 1.15.174 2.288.535 3.371a7.733 7.733 0 002.047 3.198c1.713 1.619 4.067 2.422 7.038 2.422 2.02 0 3.625-.429 4.83-1.298 1.137-.83 1.953-2.074 2.421-3.746a.202.202 0 00-.134-.241c-.013.026-.04.026-.053.026z"
  }))));
}

export default __webpack_public_path__ + "static/bscs.95e16426.svg";
export { SvgBscs as ReactComponent };